export const scheduleJobOptionStyles = {
  userRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '4px 8px',
    cursor: 'pointer',
    margin: '0.5px 16px',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: '#f7f8fa'
    }
  },
  userRowLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    minWidth: 0
  },
  userRowName: {
    fontSize: 16,
    fontWeight: 400,
    color: '#394860',
    lineHeight: '22px',
    whiteSpace: 'nowrap'
  },
  crewBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    padding: '2px 6px',
    fontSize: 10,
    fontWeight: 500,
    color: '#fff',
    lineHeight: '15px',
    whiteSpace: 'nowrap',
    flexShrink: 0
  },
  unassignedBadge: {
    backgroundColor: '#f1f3f5',
    color: '#adb5bd',
    fontWeight: 400
  },
  checkCircle: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: '2px solid #d9dee8',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.15s, border-color 0.15s'
  },
  checkCircleSelected: {
    backgroundColor: '#2e3b51',
    borderColor: '#2e3b51'
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
    height: 72,
    borderTop: '1px solid #e8ebf1',
    flexShrink: 0
  },
  deleteBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 600,
    color: '#6b7280',
    borderRadius: 3,
    padding: '8px 12px',
    '&:hover': {
      backgroundColor: '#f3f4f6'
    }
  },
  saveBtn: {
    backgroundColor: '#0766ee',
    border: 'none',
    borderRadius: 3,
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 600,
    color: '#fff',
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: '#0557cc'
    },
    '&:disabled': {
      backgroundColor: '#93c5fd',
      cursor: 'default'
    }
  }
} as const
